<div class="table-section">
    <app-pending-ehs-approval-forms-list></app-pending-ehs-approval-forms-list>
</div>